import react from 'react';
import moment from 'moment';
import { isMobile, isBrowser } from 'react-device-detect';
import { RiArrowGoBackLine } from 'react-icons/ri';
import { useNavigate } from 'react-router';

import { addComma } from 'constants/utils';
import { IEmpInPayTransfer } from 'types/salary';

interface IProps {
  RealPay: string;
  DetailData: IEmpInPayTransfer;
  isOwner: boolean;
  SELECT_DATE: string;
}

const DetailPayTop = ({ RealPay, DetailData, isOwner, SELECT_DATE }: IProps) => {
  const navigate = useNavigate();

  return (
    <div className="DP_Top">
      {isOwner == true && !isMobile && (
        <div className="DP_TopBackArea">
          <button onClick={() => navigate(-1)}>
            <RiArrowGoBackLine color={'white'} size={20} />
            <span>명세서작성</span>
          </button>
        </div>
      )}
      <div className="DP_TopBg">
        {isBrowser ? (
          <img
            src={require('assets/images/detailPayTop_d.png')}
            alt="detailPayTop_d Image"
            style={{ width: '100%', objectFit: 'contain' }}
          />
        ) : (
          <img
            src={require('assets/images/detailPayTop_m.png')}
            alt="detailPayTop_m Image"
            style={{ width: '100%', objectFit: 'contain' }}
          />
        )}
        <div className="DP_TopCnt">
          <div className="DP_TopName">
            <span>{DetailData.NAME}님의 급여명세서</span>
            <strong>{moment(SELECT_DATE).format('YYYY년 MM월')}</strong>
          </div>
          {isBrowser && <i />}
          <div className="DP_TopInfo">
            <span>실지급액</span>
            <strong>{addComma(RealPay)}원</strong>
          </div>
          {isBrowser && <i />}
          <div className="DP_TopInfo">
            <span>전송시간</span>
            {DetailData.LAST_PUSH_DATE !== '-' ? (
              <>
                <span>{moment(DetailData.LAST_PUSH_DATE).format('YYYY년MM월DD일')}</span>
                <span>{moment(DetailData.LAST_PUSH_DATE).format('HH시mm분')}</span>
              </>
            ) : (
              <span>{DetailData.LAST_PUSH_DATE}</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailPayTop;
